import type { ForceParams, GraphLayout, LayoutKind, LayoutHandlers } from './types.ts'
import { ForceLayout } from './force.ts'
import { DagreLayout } from './dagre.ts'
import { ElkLayout } from './elk.ts'

/** `forceParams` seeds the force simulation so swapping layouts (or recreating
 *  one) inherits the current repulsion / distance / collision tuning. */
export function createLayout(kind: LayoutKind, h: LayoutHandlers, forceParams?: Partial<ForceParams>): GraphLayout {
  switch (kind) {
    case 'dagre':
      return new DagreLayout(h)
    case 'elk':
      return new ElkLayout(h)
    default:
      return new ForceLayout(h, forceParams)
  }
}

export * from './types.ts'
